export default __webpack_public_path__ + "static/media/sushiswap-logo.c75bbd29.png";